import { motion } from "framer-motion";
import { useLanguage } from "@/i18n";

export const Manifesto = ({ settings }) => {
  const { t, pick } = useLanguage();
  const chapters = settings.chapters || [];
  if (!chapters.length) return null;
  return (
    <section id="manifesto" className="px-4 sm:px-8 lg:px-16 py-20 sm:py-28 border-t border-white/10" data-testid="manifesto-section">
      <p className="font-mono2 text-[11px] tracking-[0.3em] uppercase text-zinc-500 mb-3">03 —</p>
      <h2 className="font-display uppercase text-5xl sm:text-7xl tracking-wide mb-14">{t("manifesto_title")}</h2>
      <div className="flex flex-col gap-14">
        {chapters.map((c, i) => (
          <motion.div key={i} data-testid={`manifesto-chapter-${i + 1}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 border-t border-white/10 pt-10">
            <span className="font-display text-6xl lg:col-span-2 text-outline">{String(i + 1).padStart(2, "0")}</span>
            <h3 className="font-display uppercase text-3xl sm:text-4xl tracking-wider lg:col-span-4">{pick(c.title)}</h3>
            <p className="text-zinc-300 leading-relaxed lg:col-span-6 max-w-2xl">{pick(c.text)}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
